export default __webpack_public_path__ + "static/media/wishlist.3da8ab28.svg";